import * as React from 'react'

type EditModeContextType = {
  isEditMode: boolean
  isSaving: boolean
  toggleEditMode: () => void
  setEditMode: (value: boolean) => void
  startSaving: () => void
  finishSaving: () => void
}

export const EditModeContext = React.createContext<EditModeContextType | null>(null)

export function EditModeProvider({ children }: { children: React.ReactNode }) {
  const [isEditMode, setIsEditMode] = React.useState(false)
  const [savingCount, setSavingCount] = React.useState(0)

  const toggleEditMode = React.useCallback(() => {
    setIsEditMode(prev => !prev)
  }, [])

  const setEditMode = React.useCallback((value: boolean) => {
    setIsEditMode(value)
  }, [])

  const startSaving = React.useCallback(() => {
    setSavingCount(prev => prev + 1)
  }, [])

  const finishSaving = React.useCallback(() => {
    setSavingCount(prev => Math.max(0, prev - 1))
  }, [])

  const value = React.useMemo(
    () => ({
      isEditMode,
      isSaving: savingCount > 0,
      toggleEditMode,
      setEditMode,
      startSaving,
      finishSaving,
    }),
    [isEditMode, savingCount, toggleEditMode, setEditMode, startSaving, finishSaving]
  )

  return <EditModeContext.Provider value={value}>{children}</EditModeContext.Provider>
}

